// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  padding: 0.5rem;
  width: 117px;
  /* background: linear-gradient(to bottom, #595959 0%, #595959 80%, #f97316 100%); */
  /* border-right: 2px solid #2C3948; */
  background: #484848;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 1000;
  color: #fffdfc;
}

.sidebar .first-section {
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  height: 100vh;
  justify-content: center;
  width: 100%;
}

.sidebar.collapsed {
  width: 64px;
}

/* Survol d'une sidebar repliee : elle se redeploie en douceur (overlay du contenu, pas de reflow). */
.sidebar.collapsed:hover {
  width: 117px;
}

/* Libelles : toujours dans le DOM (pour pouvoir s'animer), masques quand repliee et non survolee. */
.sidebar-label {
  white-space: nowrap;
  overflow: hidden;
  max-height: 2.4rem;
  opacity: 1;
  transition: opacity 0.2s ease, max-height 0.25s ease;
}
.sidebar.collapsed:not(:hover) .sidebar-label {
  opacity: 0;
  max-height: 0;
}

.collapse-btn {
  width: 33px;
  height: 33px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: fixed;
  left: 17.8rem;
  top: 50vh;
}

.titre-espace,
.sidebar .name {
  font-weight: 700;
}

.collapse-btn.collapsed {
  left: 6.7rem;
}

.collapse-arrow {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.collapse-arrow.collapsed {
  transform: rotate(180deg);
}

/* Espaceur haut = hauteur de la tuile logo (64px, fixe au-dessus de la sidebar)
   pour que la premiere icone du menu demarre dessous. */
.sidebar-header {
  width: 100%;
  min-height: 60px;
}

.sidebar-header .user-info {
  font-weight: bold;
}

.sidebar .user-info .org {
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.sidebar-menu {
  list-style: none;
  margin: 1rem 0;
  /* height: 60%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
}

.sidebar-link {
  /* display: flex; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  font-weight: 400;
  color: #fffdfc;
  padding: 1rem 0.5rem;
  border-radius: 8px;
  gap: 0.5rem;
  width: 100%;
}

.sidebar-link:hover,
.sidebar-link.active {
  background: #f97316;
  color: #fffdfc !important;
  cursor: pointer;
}

.sidebar-link.active {
  font-weight: 900;
}

.sidebar-link span {
  margin: auto;
}

.icon,
.icon-white {
  width: 28px;
  height: 28px;
  transition: width 0.25s ease, height 0.25s ease;
  /* fill: white; */
  /* margin: auto; */
}

/* .icon path {
  fill: #2C3948;
} */

.sidebar .badge {
  background: #e2411d;
  color: #fffdfc;
  border-radius: 9999px; /* rend la forme pill */
  padding: 0 0.75rem; /* horizontal padding adaptable */
  height: 22px;
  font-size: 1.2rem;
  line-height: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0; /* badge en position:absolute -> pas de decalage, le right pilote l'ancrage */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 22px; /* pour garder une taille minimum */
}

.sidebar .badge {
  position: absolute;
  right: 4px;
  top: 0;
}

/* Replie (hors survol) : pastille plus petite ; elle grossit en douceur quand la sidebar s'ouvre
   (transition: all heritee). Meme ancrage right -> grossit sur place, pas de saut de position. */
.sidebar.collapsed:not(:hover) .badge {
  height: 18px;
  line-height: 18px;
  min-width: 18px;
  font-size: 1rem;
  padding: 0 0.5rem;
}

.sidebar li {
  position: relative;
}

.logout-btn {
  border: none;
  background-color: transparent;
  width: 100%;
}

.logout-btn span {
  font-weight: 400;
}

/* Icônes plus petites en replie (22px) ; le survol restaure 28px via la regle de base (:not(:hover)). */
.sidebar.collapsed:not(:hover) .icon,
.sidebar.collapsed:not(:hover) .icon-white {
  width: 22px;
  height: 22px;
}

.sidebar-link.disabled {
  color: #999; /* gris */
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.5; /* grise le texte et l'icône */
}

.sidebar-link.disabled .icon {
  fill: #aaa; /* si tes icônes sont des SVG, ça change la couleur */
}

/* FRONT-10: Badge d'avertissement profil incomplet */
.sidebar .badge-warning {
  background: #e2411d;
  color: #fffdfc;
  /* border-radius: 50%; */
  /* width: 22px;
  height: 22px; */
  font-size: 1.1rem;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 4px;
  top: 0px;
  padding: 0 0.75rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Replie (hors survol) : pastille completion plus petite ; grossit a l'ouverture. */
.sidebar.collapsed:not(:hover) .badge-warning {
  font-size: 0.95rem;
  padding: 0 0.45rem;
}
`, "",{"version":3,"sources":["webpack://./src/composants/SideBar/SideBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,mFAAmF;EACnF,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,mDAAmD;EACnD,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,qGAAqG;AACrG;EACE,YAAY;AACd;;AAEA,oGAAoG;AACpG;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,oDAAoD;AACtD;AACA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;wDACwD;AACxD;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB,EAAE,uBAAuB;EAC9C,kBAAkB,EAAE,iCAAiC;EACrD,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,6EAA6E;EAC7F,iDAAiD;EACjD,eAAe,EAAE,mCAAmC;AACtD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;AACR;;AAEA;iGACiG;AACjG;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wGAAwG;AACxG;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW,EAAE,SAAS;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY,EAAE,8BAA8B;AAC9C;;AAEA;EACE,UAAU,EAAE,qDAAqD;AACnE;;AAEA,qDAAqD;AACrD;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB;iBACe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA,oFAAoF;AACpF;EACE,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".sidebar {\r\n  padding: 0.5rem;\r\n  width: 117px;\r\n  /* background: linear-gradient(to bottom, #595959 0%, #595959 80%, #f97316 100%); */\r\n  /* border-right: 2px solid #2C3948; */\r\n  background: #484848;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  position: fixed;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  z-index: 1000;\r\n  color: #fffdfc;\r\n}\r\n\r\n.sidebar .first-section {\r\n  display: flex;\r\n  align-content: space-between;\r\n  flex-wrap: wrap;\r\n  height: 100vh;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.sidebar.collapsed {\r\n  width: 64px;\r\n}\r\n\r\n/* Survol d'une sidebar repliee : elle se redeploie en douceur (overlay du contenu, pas de reflow). */\r\n.sidebar.collapsed:hover {\r\n  width: 117px;\r\n}\r\n\r\n/* Libelles : toujours dans le DOM (pour pouvoir s'animer), masques quand repliee et non survolee. */\r\n.sidebar-label {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  max-height: 2.4rem;\r\n  opacity: 1;\r\n  transition: opacity 0.2s ease, max-height 0.25s ease;\r\n}\r\n.sidebar.collapsed:not(:hover) .sidebar-label {\r\n  opacity: 0;\r\n  max-height: 0;\r\n}\r\n\r\n.collapse-btn {\r\n  width: 33px;\r\n  height: 33px;\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: fixed;\r\n  left: 17.8rem;\r\n  top: 50vh;\r\n}\r\n\r\n.titre-espace,\r\n.sidebar .name {\r\n  font-weight: 700;\r\n}\r\n\r\n.collapse-btn.collapsed {\r\n  left: 6.7rem;\r\n}\r\n\r\n.collapse-arrow {\r\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.collapse-arrow.collapsed {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* Espaceur haut = hauteur de la tuile logo (64px, fixe au-dessus de la sidebar)\r\n   pour que la premiere icone du menu demarre dessous. */\r\n.sidebar-header {\r\n  width: 100%;\r\n  min-height: 60px;\r\n}\r\n\r\n.sidebar-header .user-info {\r\n  font-weight: bold;\r\n}\r\n\r\n.sidebar .user-info .org {\r\n  font-size: 1.8rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.sidebar-menu {\r\n  list-style: none;\r\n  margin: 1rem 0;\r\n  /* height: 60%; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  width: 100%;\r\n}\r\n\r\n.sidebar-link {\r\n  /* display: flex; */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  font-weight: 400;\r\n  color: #fffdfc;\r\n  padding: 1rem 0.5rem;\r\n  border-radius: 8px;\r\n  gap: 0.5rem;\r\n  width: 100%;\r\n}\r\n\r\n.sidebar-link:hover,\r\n.sidebar-link.active {\r\n  background: #f97316;\r\n  color: #fffdfc !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.sidebar-link.active {\r\n  font-weight: 900;\r\n}\r\n\r\n.sidebar-link span {\r\n  margin: auto;\r\n}\r\n\r\n.icon,\r\n.icon-white {\r\n  width: 28px;\r\n  height: 28px;\r\n  transition: width 0.25s ease, height 0.25s ease;\r\n  /* fill: white; */\r\n  /* margin: auto; */\r\n}\r\n\r\n/* .icon path {\r\n  fill: #2C3948;\r\n} */\r\n\r\n.sidebar .badge {\r\n  background: #e2411d;\r\n  color: #fffdfc;\r\n  border-radius: 9999px; /* rend la forme pill */\r\n  padding: 0 0.75rem; /* horizontal padding adaptable */\r\n  height: 22px;\r\n  font-size: 1.2rem;\r\n  line-height: 22px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-left: 0; /* badge en position:absolute -> pas de decalage, le right pilote l'ancrage */\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  min-width: 22px; /* pour garder une taille minimum */\r\n}\r\n\r\n.sidebar .badge {\r\n  position: absolute;\r\n  right: 4px;\r\n  top: 0;\r\n}\r\n\r\n/* Replie (hors survol) : pastille plus petite ; elle grossit en douceur quand la sidebar s'ouvre\r\n   (transition: all heritee). Meme ancrage right -> grossit sur place, pas de saut de position. */\r\n.sidebar.collapsed:not(:hover) .badge {\r\n  height: 18px;\r\n  line-height: 18px;\r\n  min-width: 18px;\r\n  font-size: 1rem;\r\n  padding: 0 0.5rem;\r\n}\r\n\r\n.sidebar li {\r\n  position: relative;\r\n}\r\n\r\n.logout-btn {\r\n  border: none;\r\n  background-color: transparent;\r\n  width: 100%;\r\n}\r\n\r\n.logout-btn span {\r\n  font-weight: 400;\r\n}\r\n\r\n/* Icônes plus petites en replie (22px) ; le survol restaure 28px via la regle de base (:not(:hover)). */\r\n.sidebar.collapsed:not(:hover) .icon,\r\n.sidebar.collapsed:not(:hover) .icon-white {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.sidebar-link.disabled {\r\n  color: #999; /* gris */\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n  opacity: 0.5; /* grise le texte et l'icône */\r\n}\r\n\r\n.sidebar-link.disabled .icon {\r\n  fill: #aaa; /* si tes icônes sont des SVG, ça change la couleur */\r\n}\r\n\r\n/* FRONT-10: Badge d'avertissement profil incomplet */\r\n.sidebar .badge-warning {\r\n  background: #e2411d;\r\n  color: #fffdfc;\r\n  /* border-radius: 50%; */\r\n  /* width: 22px;\r\n  height: 22px; */\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  position: absolute;\r\n  right: 4px;\r\n  top: 0px;\r\n  padding: 0 0.75rem;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n/* Replie (hors survol) : pastille completion plus petite ; grossit a l'ouverture. */\r\n.sidebar.collapsed:not(:hover) .badge-warning {\r\n  font-size: 0.95rem;\r\n  padding: 0 0.45rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
